import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import './Navbar.css';


import '../i18n';
import { useTranslation } from 'react-i18next';


export default function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  const { t } = useTranslation();

  useEffect(() => {
    showButton();
    window.addEventListener('resize', showButton);
    return () => window.removeEventListener('resize', showButton);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
            IURIX
          </Link>
          <div className='menu-icon' onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className='nav-item'>
              <Link
                to='/blog'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                {t('Blog.text')}
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/finances'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                {t('Finance.text')}
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/jobs'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                {t('Jobs.text')}
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='/portfolio'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                {t('Portfolio.text')}
              </Link>
            </li>

          {/*
            <li className='nav-item'>
              <Link
                to='/home/#contact'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                 {t('Contact.text')}
              </Link>
            </li>
        */}

            <li>
              <Link
                to='/home/#services'
                className='nav-links-mobile'
                onClick={closeMobileMenu}
              >
                 {t('SIGN_UP.text')}
              </Link>
            </li>
          </ul>
          {button && <Button buttonStyle='btn--outline'> {t('SIGN_UP.text')}</Button>}
        </div>
      </nav>
    </>
  );
}
